import * as ProgressPrimitive from "@radix-ui/react-progress";
import {
	type ComponentPropsWithoutRef,
	type ElementRef,
	forwardRef,
} from "react";
import { cn } from "../lib/cn";

export interface ProgressBarProps
	extends ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
	label?: string;
	showValue?: boolean;
}

const ProgressBar = forwardRef<
	ElementRef<typeof ProgressPrimitive.Root>,
	ProgressBarProps
>(({ className, value, label, showValue = false, ...props }, ref) => (
	<div className="flex flex-col gap-1.5 w-full">
		{(label ?? showValue) && (
			<div className="flex justify-between items-center text-xs text-mutedForeground">
				{label && <span>{label}</span>}
				{showValue && <span>{value ?? 0}%</span>}
			</div>
		)}
		<ProgressPrimitive.Root
			ref={ref}
			className={cn(
				"relative h-2 w-full overflow-hidden rounded-full bg-secondary",
				className,
			)}
			{...props}
			value={value}
		>
			<ProgressPrimitive.Indicator
				className="h-full w-full flex-1 bg-primary transition-all"
				style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
			/>
		</ProgressPrimitive.Root>
	</div>
));
ProgressBar.displayName = "ProgressBar";

export default ProgressBar;
export { ProgressBar };
